export default "__VITE_ASSET__CQetmiyA__"